<div class="properties-comparables-sidebar" [class.close]="shouldClose">
  <section class="import-section preview-grids grids-comps">
    <div class="closeButton" (click)="onCloseClicked()"></div>
    <div class="scrollable-content">
      <div class="comps-header">
        <h3>{{'pixComps.titleSales' | translate}}</h3>
        <svg-icon src='./assets/icons/chevron-down-solid.svg'
                  [ngClass]="!isSaleGridCollapsed ? 'icon-toggle-rotate' : ''"
                  class="toggle-icon icon-black icon-toggle"
                  (click)="toggleSaleGrid()">
        </svg-icon>
      </div>
      <div *ngIf="!isSaleGridCollapsed">
        <kendo-grid [data]="pixCompsSalesResponse" (cellClose)="cellCloseHandler($event)" [scrollable]="'scrollable'">
          <kendo-grid-column field="comparable.ComparableStatus" title="{{'pixComps.compsStatus' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Label" title="{{'pixComps.label' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Value" title="{{'pixComps.value' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Description" title="{{'pixComps.description' | translate}}">
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate *ngIf="hasSalesComparables">
            {{'pixComps.noRecords' | translate}}
          </ng-template>
        </kendo-grid>
      </div>
      <div class="comps-header">
        <h3>{{'pixComps.titleLease' | translate}}</h3>
        <svg-icon src='./assets/icons/chevron-down-solid.svg'
                  [ngClass]="!isLeaseGridCollapsed ? 'icon-toggle-rotate' : ''"
                  class="toggle-icon icon-black icon-toggle"
                  (click)="toggleLeaseGrid()">
        </svg-icon>
      </div>
      <div *ngIf="!isLeaseGridCollapsed">
        <kendo-grid [data]="pixCompsLeaseResponse" (cellClose)="cellCloseHandler($event)" [scrollable]="'scrollable'">
          <kendo-grid-column field="comparable.ComparableStatus" title="{{'pixComps.compsStatus' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Label" title="{{'pixComps.label' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Value" title="{{'pixComps.value' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Description" title="{{'pixComps.description' | translate}}">
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate *ngIf="hasLeaseComparables">
            {{'pixComps.noRecords' | translate}}
          </ng-template>
        </kendo-grid>
      </div>
      <div class="comps-header">
        <h3>{{'pixComps.titleIE' | translate}}</h3>
        <svg-icon src='./assets/icons/chevron-down-solid.svg'
                  [ngClass]="!isIEGridCollapsed ? 'icon-toggle-rotate' : ''"
                  class="toggle-icon icon-black icon-toggle"
                  (click)="toggleIEGrid()">
        </svg-icon>
      </div>
      <div *ngIf="!isIEGridCollapsed">
        <kendo-grid [data]="pixCompsIEResponse" (cellClose)="cellCloseHandler($event)" [scrollable]="'scrollable'">
          <kendo-grid-column field="comparable.ComparableStatus" title="{{'pixComps.compsStatus' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Label" title="{{'pixComps.label' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Value" title="{{'pixComps.value' | translate}}">
          </kendo-grid-column>
          <kendo-grid-column field="basket.Description" title="{{'pixComps.description' | translate}}">
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate *ngIf="hasIEComparables">
            {{'pixComps.noRecords' | translate}}
          </ng-template>
        </kendo-grid>
      </div>
      <div class="buttons-container">
        <button kendoButton class="next" (click)="onCloseClicked()">{{'pixComps.previewClose' | translate}}</button>
      </div>
    </div>
  </section>
</div>
